// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const getCurrentTokenInfoHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string().describe("Bearer token")),
});

/**
 * @description token info
 */
export const getCurrentTokenInfo200Schema = z.object({
  resource_owner_id: z.optional(z.number().int()),
  scope: z.optional(z.array(z.coerce.string())),
  expires_in: z.number().int().nullish(),
  application: z.optional(z.object({
    uid: z.optional(z.coerce.string()),
    name: z.optional(z.coerce.string()),
  })),
});

/**
 * @description unauthorized
 */
export const getCurrentTokenInfo401Schema = z.unknown();

export const getCurrentTokenInfoQueryResponseSchema = z.lazy(() => getCurrentTokenInfo200Schema);
